module.exports = __webpack_public_path__ + "static/img/wolves.981a4ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/bg/old/wolves.jpg
// module id = i1tq
// module chunks = 1